// @ts-nocheck
// 获取当前周的第一天和最后一天
export function getWeekDay(e) {
    let date = new Date(e);
    let week = date.getDay(); // 0-6，0 表示星期日，
    let offset = week === 0 ? -6 : 1; // 如果日期是星期日，-6，否则为 1
    let startTime = new Date(date.getTime() - (week - 1) * 24 * 60 * 60 * 1000);
    let endTime = new Date(date.getTime() + (7 - week) * 24 * 60 * 60 * 1000);
    return {
        startTime: startTime.toLocaleDateString().replace(/\//g, "-"),
        endTime: endTime.toLocaleDateString().replace(/\//g, "-")
    };
}
// 获取当前周上一周的第一天和最后一天
export function getLastWeekDay(e) {
    let date = new Date(e);
    let week = date.getDay(); // 0-6，0 表示星期日，
    let offset = week === 0 ? -6 : 1; // 如果日期是星期日，-6，否则为 1
    let startTime = new Date(date.getTime() - (week - 1) * 24 * 60 * 60 * 1000 - 7 * 24 * 60 * 60 * 1000);
    let endTime = new Date(date.getTime() + (7 - week) * 24 * 60 * 60 * 1000 - 7 * 24 * 60 * 60 * 1000);
    return {
        startTime: startTime.toLocaleDateString().replace(/\//g, "-"),
        endTime: endTime.toLocaleDateString().replace(/\//g, "-")
    };
}
// 获取当前月的第一天和最后一天
export function getMonthDay(e) {
    let date = new Date(e)
    let y = date.getFullYear(); //获取年份
    let m = date.getMonth() + 1; //获取月份
    m = m < 10 ? '0' + m : m; //月份补 0
    let dstartTime = '01'
    let dendTime = new Date(y, m, 0).getDate(); //获取当月最后一日
    let startTime = [y, m, dstartTime].join("-")
    let endTime = [y, m, dendTime].join("-")
    return {
        startTime: startTime,
        endTime: endTime
    }
}
// 获取当前月上月的第一天和最后一天
export function getLastMonthDay(e) {
    let date = new Date(e)
    let y = date.getFullYear(); //获取年份
    let m = date.getMonth(); //获取月份
    m = m < 10 ? '0' + m : m; //月份补 0
    let dstartTime = '01'
    let dendTime = new Date(y, m, 0).getDate(); //获取当月最后一日
    let startTime = [y, m, dstartTime].join("-")
    let endTime = [y, m, dendTime].join("-")
    return {
        startTime: startTime,
        endTime: endTime
    }
}
// 获取当前实时时间
export function getCurrentDate() {
    let date = new Date();
    let time = date.toLocaleString().replace(/\//g, "-")
    return time
}
// 获取当前时间前n天的时间
export function getDaysAgo(n, e) {
    let date = new Date();
    if (e) {
        date = new Date(e);
    }
    let agoTime = date.getTime() - 3600 * 1000 * 24 * n;
    let agoDate = new Date(agoTime)
    let agoY = agoDate.getFullYear();
    let agoM = agoDate.getMonth() + 1;
    agoM = agoM < 10 ? '0' + agoM : agoM
    let agoD = agoDate.getDate();
    agoD = agoD < 10 ? '0' + agoD : agoD
    let time = `${agoY}-${agoM}-${agoD}`
    return time
}
// 获取明天时间
export function getTomorrow() {
    let date = new Date();
    let TomorrowTime = date.getTime() + 3600 * 1000 * 24 * 1;
    let Tomorrow = new Date(TomorrowTime)
    let y = Tomorrow.getFullYear(); //获取年份
    let m = Tomorrow.getMonth() + 1; //获取月份
    m = m < 10 ? '0' + m : m; //月份补 0
    let d = Tomorrow.getDate();
    d = d < 10 ? '0' + d : d;
    let time = `${y}-${m}-${d} 00:00`;
    return time
}
// 判断时间是否大于昨天，如果大于昨天返回昨天时间
export function getIsGreaterThanDay(e) {
    let time = '';
    let date = new Date(e + ' 00:00:00')
    let timer = date.getTime();

    let date1 = new Date();
    let timer1 = date1.getTime() - 60 * 60 * 24 * 1000;
    if (timer > timer1) {
        // console.log('大于昨天')
        time = getDaysAgo(1, date1)
    } else {
        // console.log('小于等于昨天')
        time = e
    }
    return time
}
// 年月日时间格式化
export function dateFormatting(date) {
    let dateData = new Date(date);
    let y = dateData.getFullYear(); //获取年份
    let m = dateData.getMonth() + 1; //获取月份
    m = m < 10 ? '0' + m : m; //月份补 0
    let d = dateData.getDate();
    d = d < 10 ? '0' + d : d;
    let time = `${y}-${m}-${d}`;
    return time
}
// 时间戳格式化
export function timestampFormatting(timestamp) {
    const now = new Date(timestamp)
    const y = now.getFullYear()
    const m = now.getMonth() + 1
    const d = now.getDate()
    return y + '-' + (m < 10 ? '0' + m : m) + '-' + (d < 10 ? '0' + d : d) + ' ' + now.toTimeString().substr(0, 8)
}
// 数组排序规则
export function sortBy(name, sort) {
    // console.log('name=' + name + ',sort=' + sort);
    return function (o, p) {
        var a, b;
        if (typeof o === "object" && typeof p === "object" && o && p) {
            a = parseInt(o[name]);
            b = parseInt(p[name]);
            if (a === b) {
                return 0;
            }
            if (sort == 'asc') {
                if (typeof a === typeof b) {
                    return a < b ? -1 : 1;
                }
                return typeof a < typeof b ? -1 : 1;
            } else {
                if (typeof a === typeof b) {
                    return a > b ? -1 : 1;
                }
                return typeof a > typeof b ? -1 : 1;
            }
        }
        else {
            throw ("error");
        }
    }
}
// 数组去重
export function unique(arr, val) {
    const res = new Map()
    return arr.filter((item) => !res.has(item[val]) && res.set(item[val], 1))
}
// 16进制转10进制
export function hex2int(hex) {
    // const len = hex.length
    // const a = new Array(len)
    // let code
    // for (let i = 0; i < len; i++) {
    //     code = hex.charCodeAt(i)
    //     if (code >= 48 && code < 58) {
    //         code -= 48
    //     } else {
    //         code = (code & 0xdf) - 65 + 10
    //     }
    //     a[i] = code
    // }

    // return a.reduce(function (acc, c) {
    //     acc = 16 * acc + c
    //     return acc
    // }, 0)
    return parseInt(hex, 16);
}
export function int2hex(num, width) {
    var hex = '0123456789abcdef'
    var s = ''
    while (num) {
        s = hex.charAt(num % 16) + s
        num = Math.floor(num / 16)
    }
    if (typeof width === 'undefined' || width <= s.length) {
        return s.toUpperCase()
    }
    var delta = width - s.length
    var padding = ''
    while (delta-- > 0) {
        padding += '0'
    }
    return padding + s.toUpperCase()
}
//  判断是pc还是移动端
export function isPc() {
    if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
        return false;
    } else {
        return true;
    }
}
// 判断是否可以json格式化
export function isJSON(str) {
    try {
        let obj = JSON.parse(str);
        return true;
    } catch (err) {
        return false
    }
}


// WEBPACK FOOTER //
// ./src/utils/utils.js